// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3YZQg","detailsBorder":"styles_detailsBorder__1r9-h"};